export default {
  colorScheme: {
    light: {
      root: {
        background: 'black'
      }
    }
  }
};